import { Tooltip } from '@mui/material';
import { Template } from 'crono-fe-common/types/template';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import RewrittenWithAiIcon from 'crono-fe-common/icons/Rewritten-With-AI-Icon';
import ManuallyPersonalisedMessageIcon from 'crono-fe-common/icons/Manually-Personalised-Message-Icon';

interface Props {
  template: Template;
}

const PersonalisedBadge = ({ template }: Props) => {
  if (
    !template.isPersonalized &&
    !template.personalizedWithAI &&
    !template.isGeneratedWithAi
  )
    return null;

  if (template.personalizedWithAI || template.isGeneratedWithAi) {
    return (
      <Tooltip
        title="Sequence rewritten with AI"
        enterDelay={200}
        enterNextDelay={200}
        arrow
      >
        <FlexDiv width={'fit-content'}>
          <RewrittenWithAiIcon />
        </FlexDiv>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      title="Message personalised manually"
      enterDelay={200}
      enterNextDelay={200}
      arrow
    >
      <FlexDiv width={'fit-content'}>
        <ManuallyPersonalisedMessageIcon />
      </FlexDiv>
    </Tooltip>
  );
};

export default PersonalisedBadge;
